<ion-header>
  <ion-toolbar>
    <ion-title>STT Inferenced History</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
  
<ion-content class="no-hover-page" [fullscreen]="true" >
  
  <ng-container>
      <ion-grid>
        <!-- Table Header Row -->
        <ion-row class="table-header">
          <ion-col size="1"><strong>Index</strong></ion-col>
          <ion-col size="5"><strong>Text</strong></ion-col>
          <ion-col size="2"><strong>Text Match</strong></ion-col>
          <ion-col size="2"><strong>Remarks</strong></ion-col>
          <ion-col size="1"><strong>User</strong></ion-col>
          <ion-col size="1"><strong>Actions</strong></ion-col>
        </ion-row>
      
        <!-- Data Rows -->
        <ion-row *ngFor="let item of historyData; let i = index" class="table-row">
          <ion-col size="1">{{ i + 1 }}</ion-col>
      
         

          <ion-col size="5">
            <div>
              <p><strong>Original Text:</strong></p>
              <p>{{ item.text }}</p>
              <p><strong>Transcribed Text:</strong></p>
              <p>{{ item.transcribed_text }}</p>

              <audio controls *ngIf="item.audio_link" preload="none">
                <source [src]="item.audio_link" type="audio/mpeg" />
                Your browser does not support the audio element.
              </audio>

            </div>
            <!-- <div>
              <p>{{ item.text }}</p>
            </div> -->
          </ion-col>
          <!-- <ion-col size="2" [ngStyle]="{ color: item.text === item.transcribed_text ? 'green' : 'red' }">
            {{ item.text === item.transcribed_text ? 'Matched' : 'Not matched' }}
          </ion-col> -->
          <ion-col size="2" [ngStyle]="{ color: isTextMatched(item.text, item.transcribed_text) ? 'green' : 'red' }">
            {{ isTextMatched(item.text, item.transcribed_text) ? 'Matched' : 'Not matched' }}
          </ion-col>
          <ion-col size="2">
            <div>
              <p>{{ item.remarks }}</p>
            </div>
          </ion-col>

          <ion-col size="1">
            <p>{{ item.user }}</p>
          </ion-col>
          
          
          
      
          <ion-col size="1">
            <div class="tooltip-wrapper">
              <ion-button class="zoom-icon-button" fill="clear" color="primary" (click)="deleteData(item)">
                <ion-icon slot="icon-only" name="trash-outline" ></ion-icon>
              </ion-button>
              <span class="custom-tooltip">Delete Data</span>
            </div>
          </ion-col>
        </ion-row>
      
        <!-- Empty State -->
        <ion-row *ngIf="historyData.length === 0">
          <ion-col>
            <p>No history found.</p>
          </ion-col>
        </ion-row>
      </ion-grid>
      
      

  </ng-container>
  
</ion-content>
    

  
